<template>
  <div v-if="active">
    <slot name="active" />
  </div>
  <div v-else="active">
    <slot name="inactive" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({podcast: Object});
const active = computed(() => props.podcast.active ?? false);
</script>
